import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Modal, Stack } from '@mantine/core';
import { MRT_EditActionButtons } from '../buttons/MRT_EditActionButtons';
import { MRT_EditCellTextInput } from '../inputs/MRT_EditCellTextInput';
export const MRT_EditRowModal = ({ open, table, }) => {
    var _a;
    const { getState, options: { onEditingRowCancel, onCreatingRowCancel, renderEditRowModalContent, renderCreateRowModalContent, mantineCreateRowModalProps, mantineEditRowModalProps, }, setEditingRow, setCreatingRow, } = table;
    const { creatingRow, editingRow } = getState();
    const row = (creatingRow !== null && creatingRow !== void 0 ? creatingRow : editingRow);
    const createModalProps = mantineCreateRowModalProps instanceof Function
        ? mantineCreateRowModalProps({ row, table })
        : mantineCreateRowModalProps;
    const editModalProps = mantineEditRowModalProps instanceof Function
        ? mantineEditRowModalProps({ row, table })
        : mantineEditRowModalProps;
    const modalProps = Object.assign(Object.assign({}, editModalProps), (creatingRow && createModalProps));
    const internalEditComponents = row
        .getAllCells()
        .filter((cell) => cell.column.columnDef.columnDefType === 'data')
        .map((cell) => (_jsx(MRT_EditCellTextInput, { cell: cell, table: table }, cell.id)));
    const handleCancel = () => {
        var _a;
        if (creatingRow) {
            onCreatingRowCancel === null || onCreatingRowCancel === void 0 ? void 0 : onCreatingRowCancel({ row, table });
            setCreatingRow(null);
        }
        else {
            onEditingRowCancel === null || onEditingRowCancel === void 0 ? void 0 : onEditingRowCancel({ row, table });
            setEditingRow(null);
        }
        row._valuesCache = {}; //reset values cache
        (_a = modalProps.onClose) === null || _a === void 0 ? void 0 : _a.call(modalProps);
    };
    return (_createElement(Modal, Object.assign({ opened: open, withCloseButton: false }, modalProps, { onClose: handleCancel, key: row.id }), (_a = ((creatingRow &&
        (renderCreateRowModalContent === null || renderCreateRowModalContent === void 0 ? void 0 : renderCreateRowModalContent({
            row,
            table,
            internalEditComponents,
        }))) ||
        (renderEditRowModalContent === null || renderEditRowModalContent === void 0 ? void 0 : renderEditRowModalContent({
            row,
            table,
            internalEditComponents,
        })))) !== null && _a !== void 0 ? _a : (_jsxs(_Fragment, { children: [_jsx("form", { onSubmit: (e) => e.preventDefault(), children: _jsx(Stack, { sx: {
                        gap: '24px',
                        paddingTop: '16px',
                        width: '100%',
                    }, children: internalEditComponents }) }), _jsx(Flex, { sx: { paddingTop: '24px', justifyContent: 'flex-end' }, children: _jsx(MRT_EditActionButtons, { row: row, table: table, variant: "text" }) })] }))));
};
//# sourceMappingURL=MRT_EditRowModal.js.map